var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopeOrgWrite = function SvgScopeOrgWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.15 6.889H11m-1.85.667v-3.6c0-.685 0-1.027-.142-1.289a1.26 1.26 0 0 0-.568-.534C8.162 2 7.798 2 7.07 2H4.73c-.728 0-1.092 0-1.37.133a1.26 1.26 0 0 0-.568.534c-.142.262-.142.604-.142 1.289V13M2 13h3.5m-.575-8.556h1.95M4.925 6.89h1.95m-1.95 2.444h1.95M8.117 12.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 0 1 1.24 1.242l-4.099 4.1c-.091.09-.137.136-.19.171a.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L8 14z"
  })));
};
export default SvgScopeOrgWrite;